module.exports = __webpack_public_path__ + "media/oriaskigyo_k.561c0eac.mp3";